/*import promotion from '../modules/promotion';*/

document.addEventListener('alpine:init', () => {
    window.Alpine.data('promotionLightbox', (config) => ({
        hideOnMobile: config.hideOnMobile ?? false, // only used in promotion twig actually
        cookieName: config.cookieName ?? false,
        open: config.open ?? false,
        openDelay: config.openDelay ?? 0,
        init() {
            const params = new URLSearchParams(window.location.search)
            if (params.has('promotion')) {
                // we can't shorten this condition, because the param is a string and would return true in both cases with a simple condition
                this.open = params.get('promotion') === 'false' ? false : true;
            }

            // Check if a modal need to be open on page-load and
            // cookieName does not exist (cookieName used for promotion)
            // and open promotion only, if no other modal is open
            setTimeout(() => {
                if(this.open && !this.validateCookie(this.cookieName) && !(window.innerWidth < 1024 && this.hideOnMobile) && !window.hideLightboxPromotion) {
                    if (!this.$store.modalStore.openModal) {
                        this.openPromotion();
                    }
                }
                this.openDelay = 0;
            }, this.openDelay);
        },
        validateCookie(cookieName) {
            return document.cookie.indexOf(cookieName) !== -1;
        },
        resize() {
            if (this.openDelay === 0) {
                let showPromotion = (window.innerWidth < 1024 && this.hideOnMobile) ? false : !this.validateCookie(this.cookieName);
                if (showPromotion && !window.hideLightboxPromotion) {
                    this.openPromotion();
                } else {
                    this.closePromotion();
                }
            }
        },
        openPromotion() {
            this.$store.modalStore.openModal = true;
            this.$store.modalStore.currentModalName = 'promotionLightbox';
            const advertising_cookie = document.querySelector('[data-lightbox-promotion-cookie]');
            const acceptButtons = advertising_cookie.querySelectorAll('[data-lightbox-promotion-cookie-click]');
            // we need to set this outside of the scope for the forEach below (this scope changes in forEach)
            const cookieName = this.cookieName;

            // Power up the accept button if exists
            if (acceptButtons.length > 0) {
                acceptButtons.forEach(button => {
                    button.addEventListener('click', function (e) {
                        window.helpers.setSecureCookie(advertising_cookie, cookieName);
                    });
                });
            }

            const backdrop = document.getElementById('backdrop');
            if(backdrop) {
                backdrop.addEventListener('click', () => {
                    window.helpers.setSecureCookie(advertising_cookie, cookieName);
                });
            }
        },
        closePromotion() {
            this.$store.modalStore.openModal = false;
            this.$store.modalStore.currentModalName = '';
        }
    }))
});
